import { Reducer, combineReducers } from 'redux';

import auth from '@store/branches/auth/reducer';
import user from '@store/branches/user/reducer';
import leads from '@store/branches/leads/reducer';
import inspirations from '@store/branches/inspirations/reducer';
import quotations from '@store/branches/inspirations/reducer';
import products from '@store/branches/products/reducer';
import projects from '@store/branches/projects/reducer';
import project from '@store/branches/project/reducer';
import chat from '@store/branches/chat/reducer';
import organizations from '@store/branches/organization/reducer';
import holidays from '@store/branches/holidays/reducer';
import customer from '@store/branches/customer/reducer';
import commercialPayments from '@store/branches/commercialPayments/reducer';
import tickets from '@store/branches/tickets/reducer';
import costings from '@store/branches/builderCosting/reducer';
import builder from '@store/branches/builder/reducer';
import dashboard from '@store/branches/dashboard/reducer';
import incentives from '@store/branches/incentives/reducer';
import feedback from '@store/branches/feedback/reducer';
import emailConfig from '@store/branches/emailConfig/reducer';
import aimagine from '@store/branches/aimagine/reducer';
import imagen from '@store/branches/imagen/reducer';

export default (): Reducer =>
	combineReducers({
		auth,
		user,
		leads,
		inspirations,
		quotations,
		projects,
		project,
		chat,
		organizations,
		holidays,
		products,
		customer,
		commercialPayments,
		tickets,
		costings,
		builder,
		dashboard,
		incentives,
		feedback,
		emailConfig,
		aimagine,
		imagen
	});
